import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Stack,
  Divider,
  Paper,
  Grid,
  Chip,
  Avatar,
  IconButton,
  Card,
  CardContent,
} from '@mui/material';
import {
  Close as CloseIcon,
  Payment as PaymentIcon,
  Person as PersonIcon,
  CalendarToday as CalendarIcon,
  Receipt as ReceiptIcon,
  AccountBalanceWallet as WalletIcon,
  CheckCircle as CheckIcon,
  Cancel as CancelIcon,
  Print as PrintIcon,
  SavingsOutlined as SavingsIcon,
} from '@mui/icons-material';
import { formatNumberWithCommas } from '../../../../utils/generalFunctions';
import { impresionrecibopago, impresionreciboabonocapital } from '../pagos/imprimirpagos';

const currencyRD = (v) => {
  if (typeof v === 'string') {
    const numValue = parseFloat(v.replace(/,/g, ''));
    if (isNaN(numValue)) return 'RD$0.00';
    return new Intl.NumberFormat("es-DO", { style: "currency", currency: "DOP" }).format(numValue);
  }
  if (typeof v === 'number' && !isNaN(v)) {
    return new Intl.NumberFormat("es-DO", { style: "currency", currency: "DOP" }).format(v);
  }
  return 'RD$0.00';
};

const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export default function DetallePagosDialog({ open, onClose, pago, onCancelPayment, onPrintReceipt, prestamo }) {
  const [pagoDetalle, setPagoDetalle] = useState(null);

  useEffect(() => {

    fetchPagoDetalle(pago?.id);
  }, [pago]);

  const fetchPagoDetalle = async (pago_id) => {
    
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/pagos-prestamo/detalle/${pago_id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
      }
    });
    if (!response.ok) {
      const error = await response.json();
      console.log(error)
      return;
    }

    const data = await response.json();
    data.pagos = data.pagos.map(p => {
      return{
        nocuota:Number(p.numero_cuota),interes:p.interesPagado,capital:p.capitalPagado,capitalPagado:p.capitalPagadoDetalle,cuotapagado:p.monto_pagado,morapagado:p.moraPagado,pendiente:p.pendiente,descuento:0,pagadodescuento:0,status:p.estado,fecha:p.fecha_pago
    }});

    setPagoDetalle(data.pagos);

    
    
  }

  const imprimirRecibo = () => {
    if (pago.tipo === 'abono_capital') {
      let metodoPago = [];
      try {
        metodoPago = typeof pago.metodo_pago === 'string'
          ? JSON.parse(pago.metodo_pago)
          : (pago.metodo_pago || []);
      } catch (e) {
        metodoPago = [];
      }
      impresionreciboabonocapital(
        localStorage.getItem('nombre_compania'),
        prestamo.cliente_identificacion,
        prestamo.cliente_nombre,
        prestamo.loan_id,
        pago.fecha_pago,
        pago.monto_pagado,
        metodoPago,
        pago.observaciones
      );
      return;
    }
    impresionrecibopago(localStorage.getItem('nombre_compania'),"Recibo de pago",pagoDetalle,prestamo.cliente_identificacion,prestamo.cliente_nombre,prestamo.loan_id,prestamo.prestamo_solicitud_id,"reimpresion","reimpresion",parseFloat(pagoDetalle[0].capitalPagado));
  }

  if (!pago) return null;

  return (  
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: '0 24px 48px rgba(0, 0, 0, 0.12)',
        }
      }}
    >
      {/* Header */}
      <DialogTitle sx={{ pb: 1, position: 'relative' }}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar
            sx={{
              backgroundColor: pago.tipo === 'abono_capital' ? '#e1f5fe' : '#e3f2fd',
              color: pago.tipo === 'abono_capital' ? '#0277bd' : '#1976d2',
              width: 48,
              height: 48
            }}
          >
            {pago.tipo === 'abono_capital' ? <SavingsIcon /> : <PaymentIcon />}
          </Avatar>
          <Box>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography variant="h6" fontWeight={700} color="text.primary">
                {pago.tipo === 'abono_capital' ? 'Detalle del Abono a Capital' : 'Detalle del Pago'}
              </Typography>
              {pago.tipo === 'abono_capital' && (
                <Chip
                  icon={<SavingsIcon />}
                  label="Abono a Capital"
                  color="info"
                  size="small"
                  variant="outlined"
                />
              )}
            </Stack>
            <Typography variant="body2" color="text.secondary">
              {pago.tipo === 'abono_capital'
                ? 'Pago extraordinario aplicado al capital del préstamo'
                : 'Información completa del pago procesado'}
            </Typography>
          </Box>
        </Stack>
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'text.secondary'
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        <Stack spacing={3}>
          {/* Payment Status Card */}
          <Card sx={{ backgroundColor: '#f8f9fa', border: '1px solid #e9ecef' }}>
            <CardContent sx={{ p: 3 }}>
              <Stack direction="row" alignItems="center" spacing={2}>
                <CheckIcon sx={{ color: '#2e7d32', fontSize: 32 }} />
                <Box>
                  <Typography variant="h6" fontWeight={600} color="success.main">
                    Pago Procesado Exitosamente
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    El pago ha sido registrado y confirmado
                  </Typography>
                </Box>
              </Stack>
            </CardContent>
          </Card>

          {/* Main Payment Information */}
          <Grid container spacing={3}>
            {/* Left Column - Payment Details */}
            <Grid item size={6}>
              <Paper variant="outlined" sx={{ p: 3, height: '100%' }}>
                <Typography variant="h6" fontWeight={600} sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
                  <ReceiptIcon color="primary" />
                  Información del Pago
                </Typography>
                
                <Stack spacing={2.5}>
                  <Box>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                      Monto Pagado
                    </Typography>
                    <Typography variant="h5" fontWeight={700} color="primary.main">
                      {currencyRD(pago.monto_pagado)}
                    </Typography>
                  </Box>

                  <Divider />

                  <Box>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                      Fecha de Pago
                    </Typography>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <CalendarIcon sx={{ color: 'text.secondary', fontSize: 18 }} />
                      <Typography variant="body1" fontWeight={500}>
                        {formatDate(pago.pago_fecha)}
                      </Typography>
                    </Stack>
                  </Box>

                  <Divider />

                  <Box>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                      Método de Pago
                    </Typography>
                    {JSON.parse(pago.metodo_pago).map((metodo) => (
                      <Chip
                        label={metodo.method+": "+formatNumberWithCommas(metodo.amount)}
                        color="primary"
                        variant="outlined"
                        sx={{ fontWeight: 500, marginLeft: 1 }}
                      />
                    ))}
                  </Box>
                </Stack>
              </Paper>
            </Grid>

            {/* Right Column - User Information */}
            <Grid item size={6}>
              <Paper variant="outlined" sx={{ p: 3, height: '100%' }}>
                <Typography variant="h6" fontWeight={600} sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
                  <PersonIcon color="primary" />
                  Información del Usuario
                </Typography>
                
                <Stack spacing={2.5}>
                  <Box>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                      Procesado Por
                    </Typography>
                    <Stack direction="row" alignItems="center" spacing={2}>
                      <Avatar sx={{ width: 32, height: 32, backgroundColor: '#e3f2fd' }}>
                        <PersonIcon sx={{ color: '#1976d2', fontSize: 18 }} />
                      </Avatar>
                      <Typography variant="body1" fontWeight={500}>
                        {pago.usuario_nombre || 'Usuario del Sistema'}
                      </Typography>
                    </Stack>
                  </Box>

                  <Divider />

                  <Box>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                      Sucursal
                    </Typography>
                    <Typography variant="body1" fontWeight={500}>
                      {pago.sucursal_name || 'N/A'}
                    </Typography>
                  </Box>

                  <Divider />

                  <Box>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                      Estado del Pago
                    </Typography>
                    <Chip
                      label={pago.estado === 'cancelado' ? 'Cancelado' : 'Completado'}
                      color={pago.estado === 'cancelado' ? 'error' : 'success'}
                      icon={pago.estado === 'cancelado' ? <CancelIcon /> : <CheckIcon />}           
                      sx={{ fontWeight: 500 }}
                    />
                  </Box>
                </Stack>
              </Paper>
            </Grid>
          </Grid>

          {/* Additional Information */}
          {(pago.observaciones || pago.referencia) && (
            <Paper variant="outlined" sx={{ p: 3 }}>
              <Typography variant="h6" fontWeight={600} sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <WalletIcon color="primary" />
                Información Adicional
              </Typography>
              
              <Stack spacing={2}>
                {pago.observaciones && (
                  <Box>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                      Observaciones
                    </Typography>
                    <Typography variant="body1" sx={{ 
                      backgroundColor: '#f5f5f5', 
                      p: 2, 
                      borderRadius: 1,
                      fontStyle: 'italic'
                    }}>
                      {pago.observaciones}
                    </Typography>
                  </Box>
                )}
                
                {pago.referencia && (
                  <Box>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                      Referencia
                    </Typography>
                    <Typography variant="body1" fontWeight={500} fontFamily="monospace">
                      {pago.referencia}
                    </Typography>
                  </Box>
                )}
              </Stack>
            </Paper>
          )}
        </Stack>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 1, justifyContent: 'space-between' }}>
        <Button
          onClick={() => imprimirRecibo()}
          variant="outlined"
          color="primary"
          startIcon={<PrintIcon />}
          disabled={pago.estado === 'cancelado'}
          sx={{
            fontWeight: 600,
            px: 4,
            py: 1.5,
            borderColor: 'primary.main',
            '&:hover': {
              borderColor: 'primary.dark',
              backgroundColor: 'primary.light',
              color: 'primary.dark'
            }
          }}
        >
          Imprimir Recibo
        </Button>
        
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              fontWeight: 600,
              px: 4,
              py: 1.5,
            }}
          >
            Cerrar
          </Button>
          {pago.estado !== 'cancelado' && (
          <Button
            onClick={() => onCancelPayment && onCancelPayment(pago)}
            variant="contained"
            color="error"
            startIcon={<CancelIcon />}
            sx={{
              fontWeight: "bold",
              px: 4,
              py: 1.5,
              borderColor: 'error.main',
              '&:hover': {
                borderColor: 'error.dark',
                backgroundColor: 'error.light',
                color: 'error.dark'
              }
            }}
          >
            {pago.tipo === 'abono_capital' ? 'Cancelar Abono' : 'Cancelar Pago'}
          </Button>
          )}
        </Box>
      </DialogActions>
    </Dialog>
  );
}
